export default "__VITE_ASSET__be32ddd5__"